export interface LetterheadModel {
    type: number;
    file: string; // base64
    width: number;
    height: number;
}

export enum LetterheadType {
    None = 0,
    TextFile = 1,
    ImageFile = 2
}